import React from 'react';

import { Grid, Box } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

export const HeaderBeneficiary = ({ headerobject }) => {
    const classes = commonStyle();

    return (
        <Box
            style={{
                marginBottom: 16,
                paddingLeft: 5
            }}
        >
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <h2 className={classes.recharge_h2}>
                        AccountHolder:
                        <span className={classes.Success_h3}>
                            {headerobject.AccountHolder}
                        </span>
                    </h2>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <h2 className={classes.recharge_h2}>
                        AccountNumber:
                        <span className={classes.Success_h3}>
                            {headerobject.AccountNumber}
                        </span>
                    </h2>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <h2 className={classes.recharge_h2}>
                        IFSC:
                        <span className={classes.Success_h3}>
                            {headerobject.IFSC}
                        </span>
                    </h2>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <h2 className={classes.recharge_h2}>
                        BankName:
                        <span className={classes.Success_h3}>
                            {headerobject.BankName}
                        </span>
                    </h2>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <h2 className={classes.recharge_h2}>
                        IsOTPVerified:
                        <span className={classes.Success_h3}>
                            {headerobject.IsOTPVerified}
                        </span>
                    </h2>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <h2 className={classes.recharge_h2}>
                        IsNameVerified:
                        <span className={classes.Success_h3}>
                            {headerobject.IsNameVerified}
                        </span>
                    </h2>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <h2 className={classes.recharge_h2}>
                        FirmName:
                        <span className={classes.Success_h3}>
                            {headerobject.FirmName}
                        </span>
                    </h2>
                </Grid>
            </Grid>
        </Box>
    );
};
